/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseExtraSchema } from "./errorResponseExtraSchema.ts";

export const errorResponseSchema = z.object({
	error_code: z.int(),
	error_message: z.string(),
	user_friendly_message: z.string().optional(),
	extra: errorResponseExtraSchema.nullable(),
});
